import { NgForOf } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { programEnumFilter, programModalityFilter } from '@constants/filter.constants';

import { DataUtils } from '@core/util/data-util.service';
import { FormatMediumDatePipe } from '@date/format-medium-date.pipe';

import { AbstractListComponent } from '@flowinn/components/filter/abstract-filter/abstract-list.component';
import { FilterComponent } from '@flowinn/components/filter/filter.component';
import { ListButtonsComponent } from '@flowinn/components/pages/list-buttons/list-buttons.component';
import { ListComponent } from '@flowinn/components/pages/list/list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateDirective } from '@language/translate.directive';

import { IProgramNews } from '@model/program-news.model';
import { SortByDirective } from '@sort/sort-by.directive';
import { SortDirective } from '@sort/sort.directive';
import { ProgramNewsService } from './program-news.service';

@Component({
  selector: 'jhi-program-news',
  standalone: true,
  imports: [
    ListButtonsComponent,
    ListComponent,
    FilterComponent,
    SortDirective,
    SortByDirective,
    FontAwesomeModule,
    TranslateDirective,
    FormatMediumDatePipe,
    NgForOf,
  ],
  templateUrl: './program-news.component.html',
})
export class ProgramNewsComponent extends AbstractListComponent<IProgramNews> {
  records: IProgramNews[] = [];

  constructor(protected pageService: ProgramNewsService, protected injector: Injector, protected dataUtils: DataUtils) {
    super(injector, 'programNews', 'programs/program-news');
  }

  initFilters(): void {
    this.filters = [programEnumFilter, programModalityFilter];
  }
}
